// extracted by mini-css-extract-plugin
export default {"Like_Icon":"LikeIcon_Like_Icon__oGF5D","liked":"LikeIcon_liked__V43DZ","light":"LikeIcon_light__AmqVg","iconColor":"LikeIcon_iconColor__K1Ttd"};